/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Automatic_Transcription_DialogInputs */



/**
* | output |
* | --- |
* | "Close automatic transcription dialog" |
*
* @param {Close_Automatic_Transcription_DialogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_automatic_transcription_dialog = /** @type {((inputs?: Close_Automatic_Transcription_DialogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Automatic_Transcription_DialogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre de transcription automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisches Transkriptionsdialogfeld schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra di dialogo della trascrizione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть диалоговое окно автоматической транскрипции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el cuadro de diálogo de transcripción automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭自动转录对话框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動転写ダイアログを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित प्रतिलेखन संवाद बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar caixa de diálogo de transcrição automática")
	return /** @type {LocalizedString} */ ("Close automatic transcription dialog")
});